import './kyc.scss';

import { LoadingSettlementHistoryItem as LoadingItem } from '@basqet-dashboard/common/components';
import { useKycInfo } from '@basqet-dashboard/common/hooks/queries';
import React from 'react';

import { ProcessKyc } from './process';
import { StartVerification } from './start-verification';

const KycSettings = () => {
  const { kycInfo, isLoading, refetchKycInfo } = useKycInfo();

  if (isLoading) {
    return (
      <div className="kyc">
        <div className="card">
          <LoadingItem />
          <LoadingItem />
        </div>
      </div>
    );
  }

  if (kycInfo && kycInfo.documentsForKycType) {
    const { documentsForKycType, docsUploaded, meta } = kycInfo;
    return (
      <ProcessKyc
        documentsForKycType={documentsForKycType}
        docsUploaded={docsUploaded}
        meta={meta}
        refetchKycInfo={refetchKycInfo}
      />
    );
  }

  return <StartVerification refetchKycInfo={refetchKycInfo} />;
};

export { KycSettings };
